namespace RioERP.Masters {
    export interface WhatsAppTemplatesRow {
        Id?: number;
        Wid?: number;
        TemplateName?: string;
        Variables?: string;
        Variable?: number[];
        Status?: Web.Enums.WhatsAppEvent;
        LanguageCode?: string;
        VariableCodes?: string;
        MessagingProduct?: string;
        Type?: Web.Enums.WhatsMessageType;
        IsActive?: boolean;
    }

    export namespace WhatsAppTemplatesRow {
        export const idProperty = 'Id';
        export const nameProperty = 'TemplateName';
        export const localTextPrefix = 'Masters.WhatsAppTemplates';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            Wid = "Wid",
            TemplateName = "TemplateName",
            Variables = "Variables",
            Variable = "Variable",
            Status = "Status",
            LanguageCode = "LanguageCode",
            VariableCodes = "VariableCodes",
            MessagingProduct = "MessagingProduct",
            Type = "Type",
            IsActive = "IsActive"
        }
    }
}
